import styled from '@emotion/styled'
import { Box, Card, Typography } from '@mui/material'
import AccordionSummary from '@mui/material/AccordionSummary'
import { colors } from '@resiliatech/birdsong'

export const PriorityAccordionSummary = styled(AccordionSummary)`
  padding: 0;

  & .MuiAccordionSummary-content {
    min-height: unset;
    margin: 0;
  }
`

export const PriorityProgressContainer = styled(Box)`
  display: flex;
  width: 100%;
`

export const BannerContainer = styled(Box)`
  display: flex;
  width: 100%;
  margin-top: 16px;
`

export const PriorityCard = styled(Card)({
  backgroundColor: colors.feedback.infoLight,
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  padding: '16px',
  height: '100%',
  flexGrow: 1,
})

export const PriorityInfo = styled(Box)`
  margin-top: 10px;
`

export const PriorityTitle = styled(Typography)`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
`

export const PriorityText = styled(Typography)`
  font-size: 14px;
  margin-bottom: 4px;
`
